import React from 'react';

import { OnboardingState, OnboardingActionContextType } from './types';

export const OnboardingContext = React.createContext<OnboardingState>({} as OnboardingState);
export const OnboardingActionContext = React.createContext<OnboardingActionContextType>(
  {} as OnboardingActionContextType
);
